import { LogoutApi } from '../../api';
import axios from '../axios';

const logoutApi = new LogoutApi(undefined, undefined, axios);

export default logoutApi;
